/*
  再入荷リクエスト（AMP Back in Stock）の画面を、LINE で受け取りたい人にも迷わない流れにする
  （2026-10-08 松本様ご指示・お試し）。

  LINE に届くのは「会員登録と同じアドレスで登録した、LINE 連携済みの会員」なので、
  アドレスを思い出させないよう、ログイン中は会員のアドレスを入れておく。

    ログイン中・連携済み … アドレスを入れておき「メールとLINEの両方に届きます」と添える
    ログイン中・未連携   … アドレスは入れない（「自動で入っている＝LINEにも届く」にそろえる）。
                            別アドレスで連携済みの人にはログインし直し、まだの人にはプロフィールの連携ボタンを案内
                            （連携済みの LINE を別アカウントで連携しようとすると CRM PLUS が弾く。2026-10-08 確認）
    ログインしていない   … 入力欄はそのまま。連携済みの会員向けに「ログインはこちら」を添える
                            ログインから戻ったら、再入荷の画面を自動で開き直す（?lf_restock=1）
  文言は 2026-10-08 松本様ご指定。

  送信後の「ありがとうございます」は、アプリが4秒で自動的に閉じてしまい読み切れないので、
  自動で閉じる予約だけ取り消す。閉じるのはお客様が「閉じる」「✕」を押したとき（2026-10-08 松本様ご指示）。
  送信後は入力欄と「リクエストする」を隠し、同じリクエストを二度送れないようにする。

  画面はアプリが #BIS_frame（about:blank の iframe）の中に描くので、テーマのCSS・HTMLは届かない。
  「再入荷リクエスト」ボタンが押されたら iframe の中に差し込む。
  アプリの作りが変わって目印が見つからないときは何もしない（画面はアプリのまま）。

  会員の情報は script タグの data 属性で受け取る（snippets/loseford-assets.liquid）。
    data-customer    … ログイン中なら "1"
    data-email       … 会員のアドレス（ログイン中のみ）
    data-linked      … LINE 連携済み（CRM PLUS が付ける顧客タグ line）なら "1"
    data-login-url   … ログインの入口
    data-logout-url  … ログアウト
    data-profile-url … 新しいマイページのプロフィール（CRM PLUS の「連携する」ボタンがある）
*/
(() => {
  const script = document.currentScript;
  if (!script) return;
  const data = script.dataset;
  const loggedIn = data.customer === '1';
  const linked = data.linked === '1';
  const REOPEN_PARAM = 'lf_restock';

  const STYLE = `
    .lf-bis-hide { display: none !important; }
    .lf-bis-note a { color: #000; text-decoration: underline; }
    .lf-bis-note { margin: -12px 0 16px; font-size: 12px; line-height: 1.6; color: #555; }
    /* 送信後は商品名と完了メッセージだけ残す（二重に送られないように） */
    #container.complete .signup-form-container { display: none !important; }
  `;

  const el = (doc, tag, className, text) => {
    const node = doc.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };

  // ログイン後に同じ商品ページへ戻り、再入荷の画面を開き直す
  const loginHref = () => {
    const url = new URL(window.location.href);
    url.searchParams.set(REOPEN_PARAM, '1');
    const back = url.pathname + url.search;
    const base = data.loginUrl || '/account/login';
    const q = encodeURIComponent(back);
    // 新しいログイン方式でどちらの名前が効くか未確認のため、両方付けておく
    return base + (base.includes('?') ? '&' : '?') + 'return_url=' + q + '&return_to=' + q;
  };

  // AMP の入力欄は素の input。値を入れたら、アプリが読む可能性のあるイベントも送っておく
  const fillEmail = (input) => {
    if (!input || input.value || !data.email) return;
    input.value = data.email;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  // アプリは送信完了で #container に complete を付け、同時に4秒後に閉じる予約（modalAutoCloseTimeout）を入れる。
  // complete が付いたら、その予約を取り消す。
  const keepOpenAfterSubmit = (doc) => {
    const container = doc.getElementById('container');
    const view = doc.defaultView;
    if (!container || !view) return;
    const cancelAutoClose = () => {
      const form = window.BIS && window.BIS.popup && window.BIS.popup.form;
      if (form && form.modalAutoCloseTimeout) {
        window.clearTimeout(form.modalAutoCloseTimeout);
        form.modalAutoCloseTimeout = null;
      }
    };
    new view.MutationObserver(() => {
      if (container.classList.contains('complete')) cancelAutoClose();
    }).observe(container, { attributes: true, attributeFilter: ['class'] });
  };

  const decorate = () => {
    const frame = document.getElementById('BIS_frame');
    let doc;
    try {
      doc = frame && frame.contentDocument;
    } catch (e) {
      return false;
    }
    const desc = doc && doc.getElementById('bis-modal-desc');
    const form = doc && doc.querySelector('.signup-form-container');
    const input = doc && doc.querySelector('#email-address input[type="email"]');
    if (!desc || !form || !input) return false;
    if (doc.documentElement.hasAttribute('data-lf-bis')) return true;
    doc.documentElement.setAttribute('data-lf-bis', '');

    const style = doc.createElement('style');
    style.textContent = STYLE;
    doc.head.appendChild(style);

    // アプリ設定の説明文（「LINE連携済みの方は〜」）は、下の案内と重なるので隠す
    desc.classList.add('lf-bis-hide');
    keepOpenAfterSubmit(doc);

    if (loggedIn && linked) {
      fillEmail(input);
      const note = el(doc, 'p', 'lf-bis-note',
        '会員登録のアドレスが表示されております。このままご登録いただくと、メールとLINEの両方にお知らせが届きます。'
        + 'また、別のメールアドレスへの通知をご希望でしたら入力してください。その場合LINEでの通知は送信されません。');
      input.closest('#email-address').insertAdjacentElement('afterend', note);
      return true;
    }

    if (loggedIn) {
      const note = el(doc, 'p', 'lf-bis-note',
        '現在ログイン中のアカウントは、LINEと連携されていません。以前に別のアドレスでLINE連携をされた方は、そのアドレスでログインし直してください');
      const logout = el(doc, 'a', '', '（ログアウトはこちら）');
      logout.href = data.logoutUrl || '/account/logout';
      logout.target = '_top';
      note.appendChild(logout);
      note.appendChild(doc.createTextNode('。LINE連携がまだの方は、プロフィールからLINEとつなげます'));
      const profile = el(doc, 'a', '', '（プロフィールはこちら）');
      profile.href = data.profileUrl || '/account';
      profile.target = '_top';
      note.appendChild(profile);
      note.appendChild(doc.createTextNode('。'));
      input.closest('#email-address').insertAdjacentElement('afterend', note);
      return true;
    }

    // ログインしていない人：入力欄はそのまま。LINE連携済みの会員向けにログインを案内する
    const note = el(doc, 'p', 'lf-bis-note',
      'LINE連携済みの会員の方は、ログインすると登録アドレスが自動で入ります。そのままご登録いただくと、LINEでもお知らせが届きます。');
    const login = el(doc, 'a', '', '（ログインはこちら）');
    login.href = loginHref();
    login.target = '_top';
    note.appendChild(login);
    input.closest('#email-address').insertAdjacentElement('afterend', note);
    return true;
  };

  // アプリは押されてから iframe の中身を書くので、少しのあいだ様子を見る
  const watch = () => {
    let tries = 0;
    const timer = window.setInterval(() => {
      tries += 1;
      if (decorate() || tries > 40) window.clearInterval(timer);
    }, 100);
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (target && target.closest && target.closest('#BIS_trigger')) watch();
  });

  // ログインから戻ってきたら、再入荷の画面を開き直す（URL の目印は消しておく）
  const params = new URLSearchParams(window.location.search);
  if (loggedIn && params.get(REOPEN_PARAM) === '1') {
    params.delete(REOPEN_PARAM);
    const rest = params.toString();
    window.history.replaceState(window.history.state, '', window.location.pathname + (rest ? '?' + rest : '') + window.location.hash);
    let tries = 0;
    const timer = window.setInterval(() => {
      tries += 1;
      const trigger = document.getElementById('BIS_trigger');
      if (trigger && trigger.offsetParent !== null) {
        window.clearInterval(timer);
        trigger.click();
      } else if (tries > 50) {
        window.clearInterval(timer);
      }
    }, 200);
  }
})();
